<script>
import { CHESS_ENGINE } from "vue-chess-shared/constants";
import BaseChessboard from "@/components/variants/BaseChessboard";
import AiWorker from "@/libs/ai/AiWorker";
import { delayMs } from "vue-chess-shared/utils";
import { AI_RANDOM_RATE_BY_LEVEL, MATCH_DEFAULT } from "@/constants";

const MIN_THINKING_TIME = 500;
const MAX_THINKING_TIME = 1000;

export default {
  name: "PvAiChessboard",

  extends: BaseChessboard,

  props: {
    aiLevel: {
      type: Number,
      default: MATCH_DEFAULT.AI_LEVEL,
    },
  },

  data() {
    return {
      aiWorker: null,
    };
  },

  computed: {},

  methods: {
    afterMove() {
      this.calculatePromotions();
      // Don't show threats to players on their live game
      if (this.showThreats && !(this.playerColor && !this.matchResult)) {
        this.paintThreats();
      }

      this.playAudio();

      if (this.premove) {
        this.board.playPremove();
      }

      if (this.playerColor && !this.matchResult) {
        this.aiNextMove();
      }
    },

    numberOfMoves() {
      const moves = this.game.history({ verbose: true });
      return moves.length;
    },

    randomMoveRate() {
      return this.numberOfMoves() > 10 &&
        this.aiLevel < AI_RANDOM_RATE_BY_LEVEL.length
        ? AI_RANDOM_RATE_BY_LEVEL[this.aiLevel]
        : -1;
    },

    async aiNextMove() {
      if (!this.playerColor || this.matchResult) return;
      if (this.playerColor === this.toColor()) return;

      if (!this.aiWorker || Math.random() < this.randomMoveRate()) {
        this.aiRandomMove();
        return;
      }

      this.aiWorker.generateMove(this.game.fen());
    },

    async aiRandomMove() {
      const moves = this.game.moves({ verbose: true });
      const randomMove = moves[Math.floor(Math.random() * moves.length)];
      if (!randomMove) return;

      const thinkingTime =
        Math.floor(Math.random() * MAX_THINKING_TIME) + MIN_THINKING_TIME;
      await delayMs(thinkingTime); // give 2s for the opponent to resolve a match

      this.aiMakeMove(randomMove);
    },

    aiMakeMove(move) {
      this.game.move(move);
      // Send move data to gameModule to handle
      this.emitMoveData(move.from, move.to);

      this.aiAfterMove();
    },

    aiAfterMove() {
      this.calculatePromotions();
      // Don't show threats to players on their live game
      if (this.showThreats && !(this.playerColor && !this.matchResult)) {
        this.paintThreats();
      }

      this.playAudio();
    },
  },

  created() {
    const aiWorker = new AiWorker();
    aiWorker.setEngine(CHESS_ENGINE.STOCKFISH);
    aiWorker.onReady = () => {
      if (this.aiLevel) aiWorker.setDepth(this.aiLevel);

      aiWorker.onMoveComplete = ({ bestMove }) => {
        if (!bestMove) {
          console.error("AiWorker can't find the next move", bestMove);
          return;
        }
        const from = bestMove.substring(0, 2);
        const to = bestMove.substring(2, 4);
        const promotion = bestMove.substring(4, 5);
        this.aiMakeMove({ from, to, promotion });
      };
      this.aiWorker = aiWorker;
    };
  },
};
</script>
